import { RoleGroups } from 'infrastructure/consts';

import type { Roles, UserType } from 'infrastructure/enums';

export const excludeDenyRoles = (accessRoles: Roles[], denyRoles: Roles[]) => {
  return accessRoles.filter((accessRole) => !denyRoles.includes(accessRole));
};

export const hasCombinedModuleAccess = (
  roleNames: string[],
  denyRolesMap: Record<UserType, Roles[]>,
  userType: UserType,
) => {
  const filteredAccessRoles = excludeDenyRoles(
    RoleGroups.AccessRolesMap[userType],
    denyRolesMap[userType],
  );
  return filteredAccessRoles.some((accessRole) =>
    roleNames.includes(accessRole),
  );
};
